import { XMarkIcon } from '@heroicons/react/20/solid';
import { connect } from 'react-redux';
import { Actions as PAYSCHEDULEACTIONS } from '@/redux/actions/payScheduleActions';
import { Actions as COMPANYACTIONS } from '@/redux/actions/companyActions';
import { Actions as PAYPERIODACTIONS } from '@/redux/actions/payPeriodActions';

import { useEffect, useState } from 'react';
import Spinner from '@/common/Spinner';
import cleanDeep from 'clean-deep';

const payFrequencyOptions = [
    { label: 'every week', payFrequency: 52, value: 'every week' },
    { label: 'every 2 weeks', payFrequency: 26, value: 'every 2 weeks' },
    { label: 'every 4 weeks', payFrequency: 13, value: 'every 4 weeks' },
    { label: 'every month', payFrequency: 12, value: 'every month' },
    { label: '4-4-5', payFrequency: 12, value: '4-4-5' },
];

const payDeadlineOptions = [
    { label: 'days before payday', value: 'days' },
    { label: 'of the month', value: 'of the month' },
];

const payDayOptions = [
    { label: 'day of the month', value: 'of the month' },
    { label: 'of the period', value: 'of the period' },
    { label: 'days after end of period', value: 'days' },
    { label: 'working days after end of period', value: 'workingdays' },
];

const UpdatePeriodTypeModal = ({
    previousType,
    proposedType,
    closeModal,
    modalOpen,
    updateCompanyDetails,
    updatingDetails,
    paySchedules,
    currentPaySchedule,
    currentOrg,
    updateSetting,
    getPayPeriods,
    deletePayPeriod,
}) => {

    const [currentType, setExistingType] = useState()
    useEffect(() => {
        if (previousType) setExistingType(previousType)
    }, [previousType])

    if (!modalOpen) return null;

    const updateDetails = () => {
        const newFrequency = payFrequencyOptions.find(f => f.value === proposedType);
        const scheduleIndex = paySchedules.findIndex(schedule => schedule.id === currentPaySchedule);

        if(scheduleIndex === -1) return;

        const schedules = [...paySchedules];

        // so it updates state and actual object
        schedules[scheduleIndex].type = proposedType;
        schedules[scheduleIndex].payFrequency = newFrequency.payFrequency;
        updateSetting(currentPaySchedule, "type", schedules[scheduleIndex].type);
        updateSetting(currentPaySchedule, "payFrequency", schedules[scheduleIndex].payFrequency);

        if (proposedType == "4-4-5" || newFrequency.payFrequency !== 12) {
            if (!schedules[scheduleIndex]?.payDay?.type || schedules[scheduleIndex]?.payDay?.type === "of the month") {
                schedules[scheduleIndex].payDay.type = payDayOptions.filter(p => p.value !== "of the month")?.[0].value;
                updateSetting(currentPaySchedule, "payDay", schedules[scheduleIndex].payDay.type, "type");
            }
            if (!schedules[scheduleIndex]?.deadline?.type || schedules[scheduleIndex]?.deadline?.type === "of the month") {
                schedules[scheduleIndex].deadline.type = payDeadlineOptions.filter(p => p.value !== "of the month")?.[0].value;
                updateSetting(currentPaySchedule, "deadline", schedules[scheduleIndex].deadline.type, "type");
            }
        }

        deletePayPeriod(schedules[scheduleIndex].id);

        updateCompanyDetails(cleanDeep({
            org: String(currentOrg),
            paySchedules: schedules,
        }, { emptyStrings: false, emptyArrays: false, emptyObjects: false }));

        // reload pay periods
        getPayPeriods();

        closeModal();
    }

    return (
        <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "scroll" }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="block block-themed block-transparent remove-margin-b" style={{ padding: 0 }}>
                        <div className="block-header bg-danger" style={{ paddingLeft: '2rem', paddingRight: '2rem' }}>
                            <ul className="block-options">
                                <li>
                                    <button className="close" type="button" aria-label="Close" onClick={() => closeModal()}><XMarkIcon className="h-6 w-6 mr-3 text-white" /></button>
                                </li>
                            </ul>
                            <h3 className="block-title">Confirm Period Type Change</h3>
                        </div>
                        <div className="modal-body">
                            <p style={{ textAlign: 'center' }}>
                                When changing pay frequency, all existing payslips and any pay periods associated to the pay schedule will be deleted.
                                <br />
                                This action <strong>cannot</strong> be undone and any data deleted <strong>cannot</strong> be recovered.
                                <br />
                                <br />
                                Are you sure you'd like to change the date
                                from <strong>{currentType}</strong> to <strong>{proposedType}</strong>?
                                <div className="clearfix" />
                            </p>

                            <div className="col-xs-12">

                                <div className="col-xs-12 text-right">
                                    <button
                                        className="btn btn-default pull-left"
                                        type="button"
                                        onClick={closeModal}
                                    >Cancel</button>
                                    <button
                                        className="btn btn-danger pull-right"
                                        type="button"
                                        disabled={updatingDetails}
                                        onClick={() => { updateDetails() }}
                                    >
                                        {updatingDetails ?
                                            <>
                                                <Spinner
                                                    style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                                                    className="animate-spin -ml-1 mr-3 h-5 w-5 "
                                                />
                                                <div style={{ float: "left", paddingLeft: 5 }}>Updating...</div>
                                            </>
                                            :
                                            'Confirm'
                                        }
                                    </button>
                                </div>
                            </div>
                            <div className='clearfix' />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {

    return {
        modalOpen: !!state.company?.updatePeriodModal?.proposedType,
        proposedType: state.company?.updatePeriodModal?.proposedType,
        paySchedules: state?.company?.settings?.paySchedules,
        currentPaySchedule: state?.company?.updatePeriodModal?.id,
        currentOrg: state?.company?.settings?.org,
        updatingDetails: state.company?.loading,
    }
}

const mapDispatchToProps = dispatch => ({
    updateSetting: (id, field, newValue, fieldType) => dispatch(PAYSCHEDULEACTIONS.updateSetting(id, field, newValue, false, fieldType)),
    closeModal: () => dispatch(COMPANYACTIONS.showUpdatePeriodTypeModal()),
    updateCompanyDetails: (date) => dispatch(COMPANYACTIONS.updateCompanyDetails(date)),
    getPayPeriods: () => dispatch(PAYPERIODACTIONS.getPayPeriods()),
    deletePayPeriod: (payScheduleId) => dispatch(PAYPERIODACTIONS.deletePayPeriod({ payScheduleId })),
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdatePeriodTypeModal);